<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <div>
        <h4 class="earth-color">OVERSTAYS</h4>
        <div class="title-decoration"></div>
      </div>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
        class="futuristic-search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="getOverstaysThisMonth"
      :search="search"
      :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td data-label="Ref">
          <router-link
            :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id }}"
          >
            <a class="futuristic-link"><u>{{ props.item.booking_ref_code }}</u></a>
          </router-link>
        </td>
        <td data-label="Vehicle Registration">{{ props.item.vehicle_registration }}</td>
        <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
        <td data-label="Entry Pax">{{ props.item.guest_total }}</td>
        <td data-label="Booking Type"><b>{{ props.item.booking_type }}</b></td>
        <td data-label="Payment Status"><b>{{ props.item.booking_payment_status }}</b></td>
        <td data-label="Status" :style="props.item.booking_color">{{ props.item.booking_check_out_status }}</td>
        <td data-label="Checkout date">{{ formated_date(props.item.booking_check_out_date) }}</td>
        <td data-label="Action">
          <v-btn
            v-if="(props.item.booking_payment_status !== 'NOT PAID' || props.item.booking_type === 'Partner Booking')"
            color="#587e27"
            :depressed="true"
            small
            @click="checkOut(props.item.booking_public_id)"
            class="futuristic-btn"
          >Check Out</v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'overstays',
  data() {
    return {
      search: '',
      columns: [
        {
          text: 'Ref',
          value: 'booking_ref_code'
        },
        {
          text: 'Vehicle Registration',
          value: 'vehicle_registration',
        },
        {
          text: 'Client Name',
          value: 'booking_done_by'
        },
        {
          text: 'Entry Pax',
          value: 'guest_total'
        },
        {
          text: 'Booking Type',
          value: 'booking_type_name'
        },
        {
          text: 'Payment Status',
          value: 'booking_payment_status'
        },
        {
          text: 'Status',
          value: 'booking_status'
        },
        {
          text: 'Checkout date',
          value: 'booking_check_out_date'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('get_overstays_this_month')
  },
  methods: {
    checkOut: function (publicId) {
      var data = {
        booking_id: publicId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('overstays_dash', data)
    }
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Card Header */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

/* Input Fields */
.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Buttons */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Data Table */
.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

/* Links */
.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

/* Alerts */
.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>